module.exports = __webpack_public_path__ + "static/img/outside-download.53050e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/outside-download.jpg
// module id = 7e7P
// module chunks = 1